import { render, staticRenderFns } from "./ProductCardsGrid.vue?vue&type=template&id=1142be76&scoped=true&"
import script from "./ProductCardsGrid.vue?vue&type=script&lang=js&"
export * from "./ProductCardsGrid.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardsGrid.vue?vue&type=style&index=0&id=1142be76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1142be76",
  null
  
)

export default component.exports